<main>
    <div class="container main">
        <div class="row">
            <div class="col">
                <form [formGroup]="form" (ngSubmit)="atualizar()">
                    <h1 class="mt-3">Cadastro de contratos</h1>
                    <div class="row">
                        <div class="form col-md-6">
                            <label>
                                <span>Produto:</span>
                                <mat-select formControlName="fk_produto" class="input">
                                    <div *ngFor="let produto of produtos">
                                        <mat-option [value]="produto.sr_id">{{produto.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </label>
                        </div>
                        <div class="form col-md-6">
                            <label>
                                <span>Cliente:</span>
                                <mat-select formControlName="fk_cliente" class="input form-control">
                                    <div *ngFor="let cliente of clientes">
                                        <mat-option [value]="cliente.sr_id">{{cliente.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form col-md-6">
                            <span>Data de expiracao do contrato:</span>
                            <mat-form-field appearance="fill">
                                <mat-label>Escolha uma data</mat-label>
                                <input matInput [matDatepicker]="picker" formControlName="ts_data_vencimento">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form col-md-6" *ngIf="tipoData!=undefined">
                            <span>{{tipoData}}</span>
                            <mat-form-field appearance="fill">
                                <mat-label>Escolha uma data</mat-label>
                                <input matInput [matDatepicker]="picker1" formControlName="ts_data">
                                <mat-hint>DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div id="buttons">
                        <button class="btn-sucesso btn btn-lg btn-success" type="submit">Atualizar</button>
                        <button (click)="cancel()" class="btn-cancelar btn btn-lg btn-danger"
                            type="btn">Cancelar</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
    <div class="load d-flex justify-content-center" *ngIf="load">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
    </div>
</main>